import { MainWrapper } from "./MainWrapper";
import style from "../../assets/scss/sub/startGuide.module.scss";
import {MemberType} from "../../types/common";
import {useState} from "react";
import {PersonalStartGuide} from "./component/PersonalStartGuide";
import {OrganStartGuide} from "./component/OrganStartGuide";
import {useTranslation} from "react-i18next";
import {useLanguage} from "../../hooks/hooks";

export function StartGuide() {
  const {t} = useTranslation("startGuide");
  const [memberType, setMemberType] = useState(MemberType.PERSONAL);
  const {isKorean}= useLanguage();

  const setPersonalMember = () => {
    setMemberType(MemberType.PERSONAL);
  };

  const setGroupMember = () => {
    setMemberType(MemberType.GROUP);
  };

  return (
    <MainWrapper showFooter={true}>
      <>
        <div className={style.bgContainer}>
          <div className={style.topBgWrapper}>
            <img
              src="https://images.feel-good.io/inspection_method/dcas_top_banner_background.png"
              className={style.topBg} alt={'dcas_top_banner_background'}
            />
          </div>
          <div className={`${style.textContainer} ${isKorean ? "" : style.en}`}>
            <div className={style.topBgSubText}>{t('topSubText')}</div>
            <div className={style.topBgMainText}>{t('topMainText')}</div>
            <img
              src="https://images.feel-good.io/inspection_method/dcas_process_main_image.png"
              className={style.mainImage} alt={'dcas_process_main_image'}
            />
          </div>
        </div>
        <div className={style.btnContainer}>
          <button className={`${style.indiBtn} ${memberType === "PERSONAL" ? style.isActive : ""} ${isKorean ? "" : style.en}`}
              onClick={setPersonalMember}>{t('button.personal')}</button>
          <button className={`${style.memberBtn} ${memberType === "GROUP" ? style.isActive : ""}  ${isKorean ? "" : style.en}`}
              onClick={setGroupMember}>{t('button.organ')}
          </button>
        </div>

        {memberType === "PERSONAL" ? (
            <PersonalStartGuide />
        ) : (
            // 소속 회원 안내
            <OrganStartGuide />
        )}
      </>
    </MainWrapper>
  );
}
